import { render, staticRenderFns } from "./PendingSurveysPrompt.vue?vue&type=template&id=918f5534&scoped=true"
import script from "./PendingSurveysPrompt.vue?vue&type=script&lang=js"
export * from "./PendingSurveysPrompt.vue?vue&type=script&lang=js"
import style0 from "./PendingSurveysPrompt.vue?vue&type=style&index=0&id=918f5534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918f5534",
  null
  
)

export default component.exports